(() => {
  'use strict';
  const element = document.getElementById('FultonsVariantSelectionData');
  if (!element) return;
  let data;
  try { data = JSON.parse(element.textContent); } catch { return; }
  window.FultonsVariantSelection = {
    requestedSku(id) {
      if (String(id) !== data.productId) return null;
      const requested = new URL(location.href).searchParams.get('variant');
      const matches = data.variants.filter(item => item.id === requested);
      return matches.length === 1 ? matches[0].sku : null;
    }
  };
})();
